import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axiosInstance";

// Modify transectionApi to accept query parameters
export const transectionApi = createAsyncThunk(
  "transection",
  async ({ startDate = null, endDate = null }) => {
    const params = {};
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    
    const response = await axiosInstance.get("/transection", { params });
    return response.data;
  }
);

const transectionSlice = createSlice({
  name: "transection",
  initialState: {
    transection: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(transectionApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(transectionApi.fulfilled, (state, action) => {
        state.transection = action.payload;
        state.loading = false;
      })
      .addCase(transectionApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default transectionSlice.reducer;


// import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
// import axiosInstance from "../../utils/axiosInstance";

// export const transectionApi = createAsyncThunk("transection", async () => {
//   const response = await axiosInstance.get("/transection");
//   return response.data;
// });

// const transectionSlice = createSlice({
//   name: "transection",
//   initialState: {
//     transection: [],
//     errors: [],
//     loading: false,
//   },
//   reducers: {},
//   extraReducers: (builder) => {
//     builder
//       .addCase(transectionApi.pending, (state) => {
//         state.loading = true;
//       })
//       .addCase(transectionApi.fulfilled, (state, action) => {
//         state.transection = action.payload;
//         state.loading = false;
//       })
//       .addCase(transectionApi.rejected, (state, action) => {
//         state.errors.push(action.error.message);
//         state.loading = false;
//       });
//   },
// });

// export default transectionSlice.reducer;
